import picture from "./assets/sunset-4432322_1280.jpg"

export const product = [
    {
        name:"Name",
        price: `${10}$`,
        description:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatum, at doloremque unde laboriosam nobis cumque sit repellat beatae. Itaque dignissimos nobis voluptatem mollitia commodi delectus minima corporis sed asperiores perferendis!",
        img: picture,
    },
]